<template>
  <div class="mx-6">
    <hr class="h-px w-full bg-dss-secondary-400/60 my-3 border-0">
  </div>
</template>
